module.exports = __webpack_public_path__ + "img/Menu-13.7a85d175.webp";